export default function StatsSection() {
  const stats = [
    { value: '580万+', label: '社交媒体粉丝' },
    { value: '45+', label: '影视作品' },
    { value: '12', label: '代言品牌' },
    { value: '30+', label: '公益活动' },
  ];

  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-accent-500" aria-label="数据统计">
      <div className="max-w-[1280px] mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="font-heading text-3xl md:text-4xl text-background-50 mb-2">{stat.value}</p>
              <p className="text-sm text-background-50/70">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}